import React, { Component } from 'react'
import { Table } from 'react-bootstrap'

class Voordrachten extends Component {
    constructor(props) {
        super(props)
        this.getLectures = this.getLectures.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getLectures() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((l, index) => {
            return <tr key={index}>
                <td>{l.name}</td>
                <td>{l.institution}</td>
                <td>{l.city}</td>
                <td>{l.country}</td>
                <td>{l.year}</td>
                <td>{l.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='5'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente voordrachten" : "Voordrachten"}</strong></h5>
                <Table responsive bordered className="voordrachten">
                    <thead>
                        <tr>
                            <th>naam voordracht</th>
                            <th>voor wie</th>
                            <th>plaats</th>
                            <th>beschrijving</th>
                            <th>jaar</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getLectures()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Voordrachten


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Voordrachten.js